/*********************************************************
 *
 * check if it is a common formatting element or has style
 * @param {HTMLNode} node html node from NodeList
 * @returns {Boolean} true if element has class
 *
 *********************************************************/
const canApplyStyle = (node) => {
  return (
    ['strong', 'i', 'b'].includes(node.nodeName.toLowerCase()) ||
    (node.classList && node.classList.length > 0)
  );
};

/*********************************************************
 *
 * get pdfmake formatted text content from html node
 * @param {HTMLNode} childNode html node from NodeList
 * @returns {Object} pdf make text object
 *
 *********************************************************/
const getFormattedContent = (childNode) => {
  // empty childnode (blank space)
  if (!childNode) {
    return [];
  }
  // base case: node is a text node or it does not have any other child nodes
  if (childNode.nodeName == '#text' || childNode.children.length === 0) {
    let content = [];
    let text = childNode.textContent;

    // handle "summary" element (should consider it expanded so split into new line)
    if (childNode.nodeName === 'SUMMARY') text = childNode.textContent + '\n';

    if (canApplyStyle(childNode)) {
      // if there is class applied, use class name as style otherwise apply default
      // TODO: what if there are multiple class names? should it be changed to id instead?
      let style =
        childNode.classList.length > 0 ? childNode.classList[0] : childNode.nodeName.toLowerCase();

      content = [
        {
          text: text,
          style: style,
        },
      ];
    } else {
      content = [text];
    }

    return content;
  }
  //there are multiple childNodes, recurse
  else {
    let contents = [];
    childNode.childNodes.forEach((node) => {
      contents = contents.concat(getFormattedContent(node));
    });

    // style the parent
    if (canApplyStyle(childNode)) {
      return {
        text: contents,
        style:
          childNode.classList.length > 0
            ? childNode.classList[0]
            : childNode.nodeName.toLowerCase(),
      };
    }
    return contents;
  }
};

/*********************************************************
 *
 * format pigeondoc text to a pdfmake object
 * @param {Object} content pigeondoc text node
 * @param {Object} meta pigeondoc meta object (contains any config)
 * @returns {Object} has 2 possible return values
 *
 * 1. if it is a single text object it will return text type
 *  {
 *    text: [content]
 *  }
 * 2. if it has multiple text objects (ie. has nested html) it will return a stack
 *  {
 *    stack: [content]
 *  }
 *
 *********************************************************/
export default (content, meta = {}) => {
  // TODO: check if there is any HTMl in text, if none return

  // convert content to DOMParser to make traversing through any HTML easier
  let parsed = new DOMParser().parseFromString(content, 'text/html');

  let allContent = [];
  let type = 'text'; // keep track of what type of pdfmake object we need

  // convert all content to pdfMake compatible array
  parsed.body.childNodes.forEach((childNode) => {
    const result = getFormattedContent(childNode);
    if (Array.isArray(result)) allContent = allContent.concat(result);
    else {
      type = 'stack';
      allContent.push(result);
    }
  });

  // setup text object
  let obj = {};
  if (meta.pdfConfig) obj = { ...obj, ...meta.pdfConfig };
  type == 'text' ? (obj.text = allContent) : (obj.stack = allContent);

  return obj;
};
